export default "__VITE_ASSET__CS5xQMy8__";